import moment from "moment"

export const FormatDate = (date: string | Date | null) => {
    if (date)
        return moment(date).format("YYYY-MM-DD");
    return date;
}

export const DisplayDate = (date: string | Date | null) => {
    if (date)
        return moment(date).format("DD-MM-YYYY");
    return date;
}

export const FormatTime = (time: string | Date | null) => {
    if (time)
        return moment(time).format("HH:mm");
    return time;
}